var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-image-wrapper p-3",staticStyle:{"padding-bottom":"0.5rem !important"}},[_c('b-carousel',{attrs:{"id":"carousel-1","interval":3000,"controls":"","fade":"","wrap":true,"indicators":""}},[_c('b-carousel-slide',{attrs:{"img-src":"https://space-tech.sgp1.cdn.digitaloceanspaces.com/sabai88/sabai88-banner.webp"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }